export enum GameState {
    Default = 'Default',
    Wasted = 'Wasted',
}
